import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlowArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 32h43M43 22l10 10-10 10",
		stroke: "currentColor",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFlowArrow;
